<!-- pass.masterPass.name/sheet.masterSheet.name -->
<template>
  <div class="ps-face-ticket-name">
    {{ ticketName }}
  </div>
</template>

<script>
export default {
  name: "PSFaceTicketNameDisp",
  props: {
    ticketName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.ps-face-ticket-name {
  position: absolute;
  top: 80px;
  margin-left: 15px !important;
  font-size: 17px !important;
  font-weight: bold;
}
</style>
